// extracted by mini-css-extract-plugin
module.exports = {"toast":"style_toast__2DaSM","header":"style_header__3Af2m","close":"style_close__HWmUv","contents":"style_contents__3DQs2"};